import styled from 'styled-components'
import {
  PRIMARY_BLUE_02,
  GRAY_SCALE_09,
  GRAY_SCALE_05,
  PRIMARY_RED_01,
  SECONDARY_BLUE_01,
  GRAY_SCALE_10,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`

export const FormTitle = styled.h3`
  color: ${PRIMARY_BLUE_02};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin: 0;
`

export const FormSubtitle = styled.p`
  color: ${GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FormLabel = styled.label`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const FormSelect = styled.select`
  padding: 12px 16px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
  background-color: ${WHITE};
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${SECONDARY_BLUE_01};
  }
`

export const FormOption = styled.option`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

export const ArtistButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
  background-color: ${WHITE};
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${SECONDARY_BLUE_01};
    background-color: ${GRAY_SCALE_10};
  }
`

export const ArtistButtonText = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const ArtistModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const ArtistModalContent = styled.div`
  background-color: ${WHITE};
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
`

export const ArtistModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const ArtistModalTitle = styled.h3`
  color: ${PRIMARY_BLUE_02};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`

export const ArtistModalClose = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${GRAY_SCALE_10};
  }
`

export const ArtistSearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
  background-color: ${WHITE};
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;

  &:focus {
    outline: none;
    border-color: ${SECONDARY_BLUE_01};
  }

  &::placeholder {
    color: ${GRAY_SCALE_05};
  }
`

export const ArtistList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ArtistItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
  background-color: ${WHITE};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${SECONDARY_BLUE_01};
    background-color: ${GRAY_SCALE_10};
  }
`

export const ArtistName = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const ArtistType = styled.span`
  color: ${GRAY_SCALE_05};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-transform: uppercase;
`

export const SelectedArtists = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`

export const SelectedArtistItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: ${GRAY_SCALE_10};
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
`

export const SelectedArtistName = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const RemoveArtistButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${PRIMARY_RED_01}20;
  }
`
